import {
  DList,
  DListResponse,
  DObjectResponse,
  TriggerTypes,
} from 'models/common.model';

export enum EPaymentMethodTypes {
  MOMO = 1,
  VN_PAY = 2,
}

export type StoreModel = {
  id: number;
  subscriberId: number;
  code: number;
  name: string;
  color: string;
  address: number;
  provinceId: number;
  provinceName: string;
  districtId: number;
  districtName: string;
  wardId: number;
  wardName: string;
  createdBy: number;
  lastUpdatedBy: number;
  isActive: boolean;
  subscriberName: string;
  // TODO: refactor types
  booths: any[];
  thumbnail: string;
  longitude: string;
  latitude: string;
  imageUrl: string;
  chartColor: string;
  chartOrderNo: number;
  paymentType: number;
  paymentConfig:
    | string
    | {
        id: number;
        config: string;
      }[]
    | null;
};
export type GetStoreRequestModel = {
  id?: number;
};
export type GetStoreResponseModel = DObjectResponse<StoreModel>;
export type ListStoreRequestModel = {
  pageIndex?: number;
  pageSize?: number;
  name?: string;
  subscriberId?: number;
  provinceId?: number;
  districtId?: number;
  wardId?: number;
  isActive?: boolean | null;
};
export type ListStoreResponseModel = DListResponse<StoreModel>;

export type SaveStoreRequestModel = {
  id?: number;
  subscriberId: number;
  name: string;
  address: string;
  provinceId: number | null;
  districtId: number | null;
  wardId: number | null;
  thumbnail?: string;
  longitude?: string;
  latitude?: string;
  paymentType?: number | null;
  paymentConfig?:
    | {
        AccessKey?: string;
        PartnerCode?: string;
        SecretKey?: string;
        TmnCode?: string;
        HashSecret?: string;
      }
    | string
    | null;
};
export type SaveStoreResponseModel = DObjectResponse<boolean>;

export type DeleteStoreRequestModel = {
  id?: number;
};
export type DeleteStoreResponseModel = DObjectResponse<boolean>;

export type InactiveStoreRequestModel = {
  id?: number;
  reason: string;
};
export type InactiveStoreResponseModel = DObjectResponse<boolean>;

export type ActiveStoreRequestModel = {
  id?: number;
  reason: string;
};
export type ActiveStoreResponseModel = DObjectResponse<boolean>;

export interface StoreStateModel {
  storeListData: DList<StoreModel> | null;
  storeDetail: StoreModel | null;
  triggerSaveStore?: TriggerTypes | null;

  loadingList: boolean;
  loadingDetail: boolean;
}
